/* eslint-disable prefer-template */
/* eslint-disable no-else-return */
/* eslint-disable no-restricted-syntax */
/* eslint-disable jsx-a11y/aria-role */
/* eslint-disable consistent-return */
/* eslint-disable camelcase */
/* eslint import/no-cycle: [1, { maxDepth: 1 }] */
import React, {
  useState, useEffect, useContext, useCallback,
} from 'react';
import {
  Button, Typography, Modal, Backdrop, Fade, Grid, useMediaQuery, CircularProgress,
} from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';

import './FollowButton.css';
import { followStreamer as followStreamerFunc, getUser } from '@shared/services/userApi';
import { UserContext } from '@context/UserContext';
import StringTruncate from '@shared/utils/StringTruncate';
import LoginModalComponent from '@features/Authentication';

import BanUser from '@features/UserAccountBan';
import LockUser from '@features/UserAccountLock';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: '9999',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    color: '#000',
    width: '100%',
    maxWidth: '400px',
    height: '200px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '0 10px',
  },
}));

function FollowButton(streamer) {
  // user details
  const streamer_id = streamer.data.guid ? streamer.data.guid : streamer.data.user_id;
  const { username } = streamer.data;
  const userImage = streamer.data.avatar;
  const { loggedIn, setLoggedIn } = useContext(UserContext); // profile data - store
  const relation_data = streamer.data.user_info
    ? streamer.data.user_info.relation_status : streamer.data.relation_status;
  const streamer_feed_id = streamer.fid ? streamer.fid : streamer.data.feed_id || null;

  const [relation, setRelation] = useState(relation_data);
  const [followBtn, setFollowBtn] = useState('');
  const [btnClass, setBtnClass] = useState('');
  const [modalStatus, setModalStatus] = useState(false);

  const modalClasses = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));

  // new functions and side effects for updating states inside the follow button
  const [openLoginModal, setOpenLoginModal] = useState(false);
  const openModalLogin = () => {
    setOpenLoginModal(true);
  };
  const getLoggedInAction = useCallback((data) => {
    setLoggedIn(data.loggedIn);
    setOpenLoginModal(data.modalStatus);
  }, [loggedIn, openLoginModal]);

  const modalActions = useCallback((data) => {
    setOpenLoginModal(data.modalStatus);
  }, [openLoginModal]);

  const [banModalStatus, setBanModalStatus] = useState(false);
  const [userBanDetails, setUserBanDetails] = useState([]);
  const [btnLoading, setBtnLoading] = useState(false);

  const followedSource = () => {
    if (typeof window !== 'undefined') {
      const location = window.location.pathname;
      if (location === '/') {
        return 'Popular Channel';
      } else if (location === `/${username}`) {
        return 'User Profile';
      } else if (location === `/${username}/klips/${streamer.fid}`) {
        return 'Klips Page';
      }
    }
  };

  const subPage = () => {
    if (typeof window !== 'undefined') {
      const location = window.location.pathname;
      if (location === '/') {
        return '/';
      } else if (location === `/${username}`) {
        return '/userprofile';
      } else if (location === `/${username}/klips/${streamer.fid}`) {
        return '/userprofile/klips/';
      }
    }
  };
  function followStreamer(streamerId, action) {
    setBtnLoading(true);
    followStreamerFunc(streamerId, action)
      .then((followRes) => {
        const isVip = followRes.data.data.vip_level !== '';
        const isStreamFeatured = () => followRes.data.data.type === 1;
        if (followRes.data.code === '200') {
          setFollowBtn('Following');
          if (isMobile) {
            setBtnClass('btns btn-profile-following-mobile');
          } else {
            setBtnClass('btns btn-profile-following-desktop');
          }
          setRelation(followRes.data.data.relation_status);
          setTimeout(() => setBtnLoading(false), 300);
        }
        window.analytics.track('User Followed', {
          source: followedSource(),
          subpage: subPage(),
          followed_user_id: followRes.data.data.guid,
          followed_user_level: followRes.data.data.level,
          followed_username: streamer.data.username,
          is_logged_in: !!loggedIn.guid,
          is_vip: isVip,
          feed_id: streamer_feed_id,
          is_featured: isStreamFeatured(),
        });
      })
      .catch((error) => {
        console.error(error);
      });
  }

  function unfollowStreamer(streamerId, action) {
    setBtnLoading(true);
    followStreamerFunc(streamerId, action)
      .then((unfollowRes) => {
        if (unfollowRes.data.code === '200') {
          setFollowBtn('Follow');
          if (isMobile) {
            setBtnClass('btns btn-profile-follow-mobile');
          } else {
            setBtnClass('btns btn-profile-follow-desktop');
          }
          setRelation(unfollowRes.data.data.relation_status);
          setModalStatus(false);
          setBtnLoading(false);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  // check ban status before executing function.
  const checkBanStatus = async (streamer_id_val, loggedInData) => {
    if (loggedInData.user_status === 'ban' || loggedInData.user_status === 'lock') {
      setBanModalStatus(true);
    } else if (loggedInData.user_status === 'normal') {
      if (relation === '0' || relation === '4' || !loggedIn.guid || relation === 4 || relation === 0) {
        followStreamer(streamer_id_val, 1);
      } else {
        unfollowStreamer(streamer_id_val, 0);
      }
    }
  };

  // update loggedin user profile
  const loggedInUpdate = async (streamer_id_val) => {
    await getUser(loggedIn.username)
      .then(async (userRes) => {
        if (userRes.data.code === '200') {
          setUserBanDetails(userRes.data.data.banDetails);
          await checkBanStatus(streamer_id_val, userRes.data.data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  useEffect(() => {
    if (relation === '0' || relation === '4' || !loggedIn.guid || relation === 4 || relation === 0) {
      setFollowBtn('Follow');
      if (isMobile) {
        setBtnClass('btns btn-profile-follow-mobile');
      } else {
        setBtnClass('btns btn-profile-follow-desktop');
      }
    } else {
      setFollowBtn('Following');
      if (isMobile) {
        setBtnClass('btns btn-profile-following-mobile');
      } else {
        setBtnClass('btns btn-profile-following-desktop');
      }
    }
  }, [isMobile, loggedIn, relation]);

  const [disableBtn, setDisableBtn] = useState(false);
  useEffect(() => {
    if (streamer.data.user_status === 'ban') {
      setDisableBtn(true);
    }
  }, [streamer]);

  const [loggedInStatus, setLoggedInStatus] = useState(false);
  useEffect(() => {
    if (loggedIn.guid) {
      setLoggedInStatus(true);
    }
  }, [loggedIn]);

  function follow(streamer_id_val) {
    loggedInUpdate(streamer_id_val);
  }

  const openModal = async () => {
    if (loggedIn.user_status === 'ban') {
      await loggedInUpdate(streamer_id);
    } else {
      setModalStatus(true);
    }
  };
  const closeModal = () => {
    setModalStatus(false);
  };

  const renderBtn = () => {
    if (!loggedIn.guid) {
      return <Button className={btnClass} onClick={openModalLogin} kumulabel='follow' user-loggedin={loggedInStatus.toString()}>{followBtn}</Button>;
    } else if (relation === '0' || relation === '4' || relation === 4 || relation === 0) {
      return <Button className={disableBtn === true ? btnClass + 'btn-disabled' : btnClass} onClick={() => follow(streamer_id)} disabled={disableBtn} kumulabel='follow' user-loggedin={loggedInStatus.toString()}>{followBtn}</Button>;
    } else if (btnLoading) {
      return <div className='btnLoadingDiv'><CircularProgress className='btn-loading' /></div>;
    } else {
      return <Button className={btnClass} onClick={openModal}>{followBtn}</Button>;
    }
  };

  const renderBanOrLockModal = () => {
    if (loggedIn.user_status === 'ban') {
      return (<BanUser banModalStatus={banModalStatus} userBanDetails={userBanDetails} />);
    } else if (loggedIn.user_status === 'lock') {
      return (<LockUser banModalStatus={banModalStatus} />);
    }
  };

  return (
    <>
      {renderBtn()}
      {openLoginModal
        ? (
          <LoginModalComponent
            isOpenModal={openLoginModal}
            modalFunc={modalActions}
            loggedInFunc={getLoggedInAction}
            isOpenReCaptcha={streamer.data.isOpenReCaptcha}
          />
        ) : null}
      <Modal
        className={modalClasses.modal}
        open={modalStatus}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={modalStatus}>
          <div className={modalClasses.paper}>
            <Grid className='unfollow-body'>
              <Typography>Are you sure you want to unfollow</Typography>
              <Grid container className='user-details' justifyContent='center' alignItems='center'>
                <img src={userImage} className='streamer_img' alt='streamer-avatar' />
                <Typography>
                  {StringTruncate(username, 16)}
                  {' '}
                  ?
                </Typography>
              </Grid>
              <Grid container justifyContent='center'>
                <Button className='unfollow-btns btn-yes' onClick={() => follow(streamer_id)}>Yes</Button>
                <Button className='unfollow-btns btn-no' role='close-btn' onClick={closeModal}>No</Button>
              </Grid>
            </Grid>
          </div>
        </Fade>
      </Modal>

      {/* display ban modal if user is banned */}
      { banModalStatus === false ? '' : renderBanOrLockModal() }
    </>
  );
}

export default FollowButton;
